import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=50957b1e&scoped=true&"
import script from "./Account.vue?vue&type=script&lang=js&"
export * from "./Account.vue?vue&type=script&lang=js&"
import style1 from "./Account.vue?vue&type=style&index=1&id=50957b1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50957b1e",
  null
  
)

export default component.exports